import { render, staticRenderFns } from "./IndicadoresACM.vue?vue&type=template&id=f8c5f84a"
import script from "./IndicadoresACM.vue?vue&type=script&lang=js"
export * from "./IndicadoresACM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports